import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import ListSubheader from '@material-ui/core/ListSubheader';
import IconButton from '@material-ui/core/IconButton';
import InfoIcon from '@material-ui/icons/Info';
import { observer, inject } from 'mobx-react';

const imageURL = '/api/v1/images/';

const gridStyles = {
  gridTile: {
    width: 220,
    height: 180
  }
};

/**
 * The example data is structured as follows:
 *
 * import image from 'path/to/image.jpg';
 * [etc...]
 *
 * const tileData = [
 *   {
 *     img: image,
 *     title: 'Image',
 *     author: 'author',
 *   },
 *   {
 *     [etc...]
 *   },
 * ];
 */
@inject('customerCaseStore')
@observer
class TitlebarGridList extends Component {
  render() {
    let gridListIdTicker = 0;
    const { data } = this.props;
    return (
      <GridList>
        {data.map(tile => {
          const gridListId = gridListIdTicker++;
          return (
            <GridListTile
              style={gridStyles.gridTile}
              key={gridListId}
              onClick={() => {
                this.props.customerCaseStore.carouselToggle(gridListId);
              }}
            >
              <img src={imageURL + tile._id} alt={tile.title} />
              <GridListTileBar title={tile.title} />
            </GridListTile>
          );
        })}
      </GridList>
    );
  }
}

TitlebarGridList.propTypes = {
  classes: PropTypes.object.isRequired
};

export default TitlebarGridList;



// WEBPACK FOOTER //
// ./src/views/ViewCustomerCase/PictureGrid/PictureGrid.jsx